// Import uniwersalnego wrappera do żądań HTTP
import { fetchWrapper } from "@/helpers/fetch-wrapper";

// Serwis obsługujący białą listę tablic rejestracyjnych
class WhiteListsService {
  /**
   * Dodaje nową tablicę rejestracyjną do białej listy.
   *
   * Grupa kontaktów jest WYMAGANA — backend odrzuca żądanie bez przypisanej grupy.
   *
   * @param {string} licensePlate     Numer rejestracyjny.
   * @param {string} description      Opis pojazdu.
   * @param {number[]} contactGroupIds Identyfikatory grup kontaktów (wymagane, niepuste).
   */
  async postNewPlate(licensePlate, description, contactGroupIds = []) {
    if (!licensePlate) {
      return;
    }

    if (!Array.isArray(contactGroupIds) || contactGroupIds.length === 0) {
      throw new Error('Wskaż co najmniej jedną grupę kontaktów, do której przypisana będzie tablica.');
    }

    const response = await fetchWrapper.post(
      process.env.VUE_APP_API_URL + '/wanted-plates',
      {
        plateLpr: licensePlate,
        typeOfList: 1,             // 1 = biała, 0 = czarna
        similarity: 1,
        description: description ?? '',
        contactGroupIds,
      }
    );
    return response;
  }

  // Pobierz WSZYSTKIE wpisy z białej listy
  async getAll() {
    try {
      const params = new URLSearchParams({
        typesOfLists: [1],
        orderDirection: 'desc',
        page: 1,
        limit: 1000
      });

      const response = await fetchWrapper.get(
        `${process.env.VUE_APP_API_URL}/wanted-plates?${params.toString()}`
      );

      return response;
    } catch (error) {
      console.error('Error fetching vehicles:', error);
    }
  }

  async delete(id) {
    try {
      const response = await fetchWrapper.delete(
        `${process.env.VUE_APP_API_URL}/wanted-plates/${id}`
      );
      return response;
    } catch (error) {
      console.error('Error deleting vehicle:', error);
    }
  }
}

export default new WhiteListsService();
